export const createStyles = (theme: any) => ({
  mobileContentWrapper: {
    width: '100%',
    height: '100%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0.5rem',
    bgcolor: theme.palette.background.paper,
    overflowX: 'hidden',
  },
  mobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    p: '0.5rem 1rem 0 0.75rem',
    alignItems: 'center',
  },
  mobileHeaderRightEnd: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  mobileButtonSx: {
    width: '30px',
    height: '40px',
    borderRadius: '0.25rem',
  },
  mobileEditor: {
    px: '0.5rem',
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  alertContainer: {
    width: 'calc(100vw - 2rem)',
    maxWidth: '480px',
    height: '198px',
    bgcolor: theme.palette.background.paper,
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    p: '1rem 1rem 1.5rem 1rem',
    outline: 'none',
  },
  alertHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.75rem',
  },
  alertTitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  },
  alertClose: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
    p: '4px',
    mr: '-4px',
  },
  alertMessage: {
    mt: '1.25rem',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
    color: theme.palette.text.primary,
  },
  alertFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '0.75rem',
    mt: 'auto',
  },
  alertButton: {
    width: '78px',
    height: '42px',
    px: '1.25rem',
    textTransform: 'none',
    fontWeight: 500,
    borderRadius: '0.25rem',
  },
});
